module.exports = __webpack_public_path__ + "media/images/golf-background-b914c0df80ea5864fa9d7a23e34d7a67.jpg";